import { h } from "preact";
import { useState } from "preact/hooks";
import { Card } from "antd";
import CreateFlowTab from './CreateFlowTab.jsx'
import CreateFlowTemplateTab from "./CreateFlowTemplateTab.jsx";
import MyFlowTemplatesTab from "./MyFlowTemplatesTab.jsx";
export default function SettingsPage() {
    const [selectedTab, setSelectedTab] = useState("Create Flow");
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleSelectTemplate = (template) => {
        setSelectedTemplate(template);
        setSelectedTab("Create Flow");
    };

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
    };

    const renderTab = () => {
        switch (selectedTab) {
            case "Create Flow":
                return <CreateFlowTab
                    templateFromParent={selectedTemplate}
                    onTemplateLoaded={() => setSelectedTemplate(null)}
                />;
            case "Create Flow Template":
                return <CreateFlowTemplateTab />
            case "My Flow Templates":
                return <MyFlowTemplatesTab onSelectTemplate={handleSelectTemplate} />;
            default:
                return <CreateFlowTab
                    templateFromParent={selectedTemplate}
                    onTemplateLoaded={() => setSelectedTemplate(null)}
                />;
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="flows-tab-bar">
                <div
                    className={`settings-tab ${selectedTab === "Create Flow" ? "selected" : ""}`}
                    onClick={() => handleTabClick("Create Flow")}
                >
                    <h4
                        className={`settings-tab-text ${
                            selectedTab === "Create Flow" ? "selected" : ""
                        }`}
                    >
                        Create Flow
                    </h4>
                </div>
                <div
                    className={`settings-tab ${
                        selectedTab === "Create Flow Template" ? "selected" : ""
                    }`}
                    onClick={() => handleTabClick("Create Flow Template")}
                >
                    <h4
                        className={`settings-tab-text ${
                            selectedTab === "Create Flow Template" ? "selected" : ""
                        }`}
                    >
                        Create Flow Template
                    </h4>
                </div>
                <div
                    className={`settings-tab ${
                        selectedTab === "My Flow Templates" ? "selected" : ""
                    }`}
                    onClick={() => handleTabClick("My Flow Templates")}
                >
                    <h4
                        className={`settings-tab-text ${
                            selectedTab === "My Flow Templates" ? "selected" : ""
                        }`}
                    >
                        My Flow Templates
                    </h4>
                </div>
            </div>
            <Card
                bordered={false}
                style={{borderRadius: "0px 0px 16px 16px"}}
            >
                {renderTab()}
            </Card>
        </div>
    );
}
